interface Props {
  onRetry: () => void;
}

const WorkspaceUsersErrorState: React.FC<Props> = ({ onRetry }) => (
  <div className="p-4 bg-red-50 rounded-md flex items-center justify-between">
    <p className="text-sm text-red-600">Failed to load workspace users.</p>
    <button
      type="button"
      onClick={onRetry}
      className="ml-4 text-sm font-medium text-red-700 underline hover:text-red-900"
    >
      Retry
    </button>
  </div>
);

export default WorkspaceUsersErrorState;
